import User from "./User";
import UserClass from "./UserClass";
const About = ()=>{
    return (
        <div>
            <User name='Shailesh Singh' contact='2948294899' leetcode='shaileshsingh23423'/>
            <UserClass name='Shailesh Singh' contact='2948294899' leetcode='shaileshsingh23423' count={0}/>
        </div>
    );
};   
export default About;